import { defineStore } from "pinia";
import { ref } from "vue";
import { API } from "@/queries/index";
import { AxiosError } from "axios";
import { APIResponse, APIResponseError } from "@/types/api";
import { handleResponse, handleResponseError } from "@/utils/api";
import { VendorDataPayload, VendorDataResponse } from "@/types/interface/vendor";

export const useVendorStore = defineStore("vendorStore", () => {
  const vendor = ref<VendorDataResponse>();
  const vendors = ref<VendorDataResponse[]>([]);

  function initVendors(data: any) {
    vendors.value = data?.data;
  }

  function addNewVendor(data: any) {
    vendor.value = data;
  }

  async function dispatchGetAll(page = 1, limit = 10, queryParam = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.vendor.getVendor(page, limit, queryParam);
      if (status === 200 ) {
        initVendors(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchDetail(idVendor = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.vendor.findVendor(idVendor);
      if (status === 200 ) {
        addNewVendor(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchCreate(payload: VendorDataPayload) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.vendor.createVendor(payload);
      if (status === 200 ) {
        addNewVendor(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchUpdate(idVendor = "", payload: VendorDataPayload) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.vendor.updateVendor(idVendor, payload);
      if (status === 200 ) {
        addNewVendor(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchDelete(idVendor = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.vendor.deleteVendor(idVendor);
      if (status === 200 ) {
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  return {
    vendor,
    vendors,
    initVendors,
    dispatchCreate,
    dispatchUpdate,
    dispatchDetail,
    dispatchGetAll,
    dispatchDelete
  };
});